import { render, staticRenderFns } from "./TemplateWidget.vue?vue&type=template&id=69790c9e&scoped=true&"
import script from "./TemplateWidget.vue?vue&type=script&lang=js&"
export * from "./TemplateWidget.vue?vue&type=script&lang=js&"
import style0 from "./TemplateWidget.vue?vue&type=style&index=0&id=69790c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69790c9e",
  null
  
)

export default component.exports